import { Col, ConfigProvider, Flex } from "antd";
import Card from "antd/es/card";
import Meta from "antd/es/card/Meta";
import { ReactElement } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./card.scss"
const AllAccessCard = ({ title, backgroundString, headTitle, isActive, link, headImg }:
    { title: ReactElement | string, backgroundString: string, headTitle: string, isActive: boolean, link?: string, headImg?: string, }): ReactElement => {
    const navigate = useNavigate();

    if (isActive == false) {
        return <></>
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorLink: "#FFFFFF",
                    colorLinkHover: "#FFFFFF",
                    colorLinkActive: "#FFFFFF",
                    linkHoverDecoration: "underline"
                },
                components: {
                    Card: {
                        borderRadius: 16,
                        borderRadiusLG: 16,
                        colorTextBase: "#FFFFFF",
                        colorTextDescription: "#FFFFFF",
                        colorTextHeading: "#FFFFFF",
                        colorLink: "#FFFFFF",
                    }
                }
            }}>
            <Col xxl={{ span: 4 }} xl={{ span: 6 }} lg={{ span: 8 }} md={{ span: 12 }} xs={{ span: 24 }}>
                <Card
                className="allAccessCard"
                    onClick={() => {
                        if (link) {
                            navigate(link);
                        }
                    }}
                    styles={{
                        header: {
                            border: "none"
                        },
                    }}
                    style={{
                        flex: "1 1 calc(50% - 15px)",
                        minHeight: "200px",
                        height: "100%",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        display: "flex",
                        cursor: "pointer",
                    }}
                >
                     {backgroundString && (
                        <img
                        src={backgroundString}
                        alt={title?.toString()}
                        style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                            borderRadius: "8px",
                        }}
                        />
                    )}

                    <div style={{ padding: "12px 14px" , marginTop: "auto"}}>
                        <div>{headTitle}</div>
                        <div className="titleText">{title}</div>
                    </div>
                </Card>
            </Col>
        </ConfigProvider>

    )
}

export default AllAccessCard;